export default "__VITE_ASSET__BQh12qJz__"